import {
    messageContainer,
    messageText,
    speechBubble,
    speechBubbleContainer,
} from './styles/DeletedMessage'
import {
    DeletedMessageProps,
} from '../types'
import React from 'react'
import {styled} from '../../../stitches/config'
import {useTranslation} from 'react-i18next'

const StyledMessageContainer = styled('div', messageContainer)
const StyledSpeechBubbleContainer = styled('div', speechBubbleContainer)
const StyledSpeechBubble = styled('div', speechBubble)
const StyledText = styled('span', messageText)

const DeletedMessage = (props: DeletedMessageProps): React.ReactElement => {
    const {isMe} = props

    const {t} = useTranslation()

    return (
        <StyledMessageContainer>
            <StyledSpeechBubbleContainer>
                <StyledSpeechBubble me={isMe}>
                    <StyledText>{t('This message was deleted')}</StyledText>
                </StyledSpeechBubble>
            </StyledSpeechBubbleContainer>
        </StyledMessageContainer>
    )
}

export default DeletedMessage
